import React from 'react'
import UserSupportContainer from '../../../../Components/SupportMessage/UserSupportContainer/UserSupportContainer'
import Layout from '../../Layout'

const UserSupport = () => {
  return (
    <Layout>
        <UserSupportContainer/>
    </Layout>
  )
}

export default UserSupport